import { Fragment, useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { useUserMe } from '../../hooks/userme';
import IconArrowDown from '../../../images/arrow-down.svg';
import IconHamburger from '../../../images/hamburger.svg';
import IconClose from '../../../images/close.svg';
import IconUser from '../../../images/user.svg';
import IconConfig from '../../../images/config.svg';
import IconLeave from '../../../images/leave.svg';
import './popover.scss';

interface IPopover {
    name: string;
}

const Popover = (props: IPopover) => {
    const { name } = props;
    const history = useHistory();
    const [userMe, setUserMe] = useUserMe();

    useEffect(() => {}, [userMe]);

    const handleOnCloseClick = () => {
        setUserMe.reset();
        history.push('/signin');
    };

    return (
        <div className="PopoverItemsMenu">
            <span className="PopoverItemsName">Hola {name}</span>
            <Menu>
                {({ open }) => (
                    <>
                        <Menu.Button as={Fragment}>
                            <span className="PopoverContentIcon">
                                <span className="PopoverIcon">
                                    <img src={IconUser} alt="" />
                                </span>
                                <span className="PopoverIcon PopoverMobile">
                                    <img
                                        className="PopoverIcon"
                                        src={open ? IconClose : IconHamburger}
                                        alt=""
                                    />
                                </span>
                                <span className="PopoverIcon PopoverDesktop">
                                    <img
                                        className="PopoverIcon"
                                        src={open ? IconClose : IconArrowDown}
                                        alt=""
                                    />
                                </span>
                            </span>
                        </Menu.Button>
                        <Transition
                            enter="PopoverEnter"
                            enterFrom="PopoverEnterFrom"
                            enterTo="PopoverEnterTo"
                            leave="PopoverLeave"
                            leaveFrom="PopoverLeaveFrom"
                            leaveTo="PopoverLeaveTo"
                        >
                            <Menu.Items as={Fragment}>
                                <ul className="PopoverUl">
                                    <Menu.Item as="li" className="PopoverLi">
                                        {({ active }) => (
                                            <NavLink
                                                className={`${
                                                    active && 'active'
                                                }`}
                                                to="/profile"
                                            >
                                                <img src={IconConfig} alt="" />
                                                Editar perfil
                                            </NavLink>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item as="li" className="PopoverLi">
                                        {({ active }) => (
                                            <span
                                                onClick={handleOnCloseClick}
                                                className={`${
                                                    active && 'active'
                                                }`}
                                            >
                                                <img src={IconLeave} alt="" />
                                                Cerrar sesión
                                            </span>
                                        )}
                                    </Menu.Item>
                                </ul>
                            </Menu.Items>
                        </Transition>
                    </>
                )}
            </Menu>
        </div>
    );
};

export default Popover;
